import { render, staticRenderFns } from "./thong-ke-loi-nhuan-dat-hang.vue?vue&type=template&id=243259cf&"
import script from "./thong-ke-loi-nhuan-dat-hang.vue?vue&type=script&lang=js&"
export * from "./thong-ke-loi-nhuan-dat-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports